import $ from 'jquery';
import { animate, createTimeline } from 'animejs';

const $root = $('html, body');

function smoothScroll() {
    $('.home__arrow-link').on('click', function (e) {
        e.preventDefault();

        $root.animate({
            scrollTop: $(this.hash).offset().top
        }, 450, () => {
            window.location.hash = this.hash;
        });
    });
}

export default () => {
    // Apply hover animation
    const arrowElement = $('.home__arrow');

    const clickTimeline = createTimeline({
      autoplay: false,
    })
    .add('.home__arrow', {
        duration: '360',
        rotateY: 1080,
        translateY: [0, -110],
        opacity: [1, 0]
    })
    .add('.home__arrow', {
        translateY: 0,
        opacity: 1,
    });

    const hoverTimeline = createTimeline({
      autoplay: false,
    })
    .add('.home__arrow', {
        duration: '120',
        rotateY: 180,
    })
    .add('.home__arrow', {
        duration: '120',
        rotateY: 0,
    });

    arrowElement.on('mouseenter', (e) => {
        hoverTimeline.restart();
    });

    arrowElement.on('click', (e) => {
        e.preventDefault();
        clickTimeline.restart();
        $('.home__arrow-link').trigger('blur');
        arrowElement.trigger('blur');
    });

    // Apply smooth scroll
    $(window).on('load', () => {
        smoothScroll();
    });
};
